module.exports = __webpack_public_path__ + "static/img/1.ed329ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/1.jpg
// module id = L0pk
// module chunks = 1